import { AgentSkill } from '../models/agent-config.model';

/**
 * The `/` command query a draft is currently expressing, or null when the draft is not one.
 *
 * A draft qualifies only while it is a single leading token — `/` followed by non-space. Once the
 * rep types a space they have committed the command and moved on to their message, so the menu
 * closes and stays closed for the rest of the line. A bare `/` yields an empty query, which lists
 * every skill.
 */
export function slashQuery(draft: string): string | null {
  const token = /^\/(\S*)$/.exec(draft);
  return token ? token[1].toLowerCase() : null;
}

/**
 * Skills matching a `/` query, in the order given. Name and keywords are matched as well as the
 * command itself, so `/onc` finds a skill named for oncology even though its command starts `e2e-`.
 *
 * An empty query lists the menu skills only. A skill with `showInMenu` false is still returned for
 * a non-empty query, so a rep who knows its command reaches it while it stays out of the browse
 * list.
 */
export function matchSkills(skills: readonly AgentSkill[], query: string): AgentSkill[] {
  if (!query) return skills.filter(s => s.showInMenu);
  return skills.filter(s =>
    s.command.includes(query)
    || s.name.toLowerCase().includes(query)
    || (s.keywords?.toLowerCase().includes(query) ?? false),
  );
}
